import React from "react";
import { PageLayout } from "../../components";
import { BranchConfirmationHelmet } from "../../components/SellHelmets";
import GreenTick from "../../images/icon--greenTick-complete.svg";
import { useSourceSystem } from "../../hooks/useSourceSystem";

export default function BranchConfirmation() {
  const { sourceSystem: { stepCount } } = useSourceSystem()

  return (
    <>
      <BranchConfirmationHelmet />
      <PageLayout>
        <PageLayout.Header step={stepCount} title="Confirmation" />
        <PageLayout.Content backgroundColour={null}>
          <div className="ch-display--flex ch-flex-flow--column-nowrap ch-text--center">
            <div className="ch-flex--none ch-pt--3">
              <img className="green-tick-size" src={GreenTick} alt="green tick" />
            </div>
            <div className="ch-flex--none ch-pt--3">
              <span className="ch-fs--4">Valuation submitted successfully</span>
            </div>
            <div className="ch-flex--none ch-pt--1">
              <span className="ch-fs--3 ch-color--grey-6">
                Return to Valuation Admin to continue.
              </span>
            </div>
          </div>
        </PageLayout.Content>
      </PageLayout>
    </>
  );
}
